import { createAction, props } from '@ngrx/store';

/**
 * Stala opisuje funkcje mozliwe do wykonania na interfejsie uzytkownika
 */
export const NarzedziaActions = {
  uruchomNarzedzie: createAction('[NARZEDZIA] uruchomNarzedzie', props<{ identyfikator: string, dane?: any }>()), // DODANO: dane
  schowajNarzedzie: createAction('[NARZEDZIA] schowajNarzedzie', props<{ identyfikator: string }>()),
  zamknijNarzedzie: createAction('[NARZEDZIA] zamknijNarzedzie', props<{ identyfikator: string }>()),
  aktualizujDane: createAction('[NARZEDZIA] aktualizujDane', props<{ identyfikator: string, dane: any }>()),
  ustawAktywneNarzedzie: createAction('[NARZEDZIA] ustawAktywneNarzedzie', props<{ narzedzieId: string }>()),
  reset: createAction('[NARZEDZIA] reset')
}
